import { Text } from '@devfolioco/genesis';
import Countdown from 'react-countdown-now';
import React from 'react';
import * as Sentry from '@sentry/browser';
import { removeCookie } from '@devfolioco/helpers';
import { createDevfolioCookie } from 'helpers/cookie';
import { getItemFromStorage, storeItem, removeItemFromStorage } from 'helpers/localStorage';
import { history } from 'helpers/history';

import { getState } from 'helpers';
import { STATE } from '@constants';

const MAX_RETRIES = 1;
const RETRY_ITEM_KEY = 'devfolio-retry-attempt';

const clearDevfolioCookies = () => {
  removeCookie('devfolio', '/quiz');
  removeCookie('devfolio', '/badges');
};

const reloadPageWithNewCookie = async quizId => {
  if (typeof window !== 'undefined') {
    clearDevfolioCookies();

    const attempts = getItemFromStorage(RETRY_ITEM_KEY);
    const updatedAttemptsCount = (attempts || 0) + 1;

    if (updatedAttemptsCount <= MAX_RETRIES) {
      storeItem(RETRY_ITEM_KEY, updatedAttemptsCount);

      await createDevfolioCookie(quizId);

      window.location.reload();
    } else {
      removeItemFromStorage(RETRY_ITEM_KEY);

      history.replace('/badges');
    }
  }
};

const Timer = ({ quizId, time, questionEndTime, onTimeout, onChange, currentTime }) => {
  const hasEndTime = typeof questionEndTime === 'number';

  let timerNow = currentTime;
  const getNow = () => {
    timerNow += 1000;
    return timerNow;
  };

  if (typeof time !== 'number' || time <= 0) {
    const { username } = getState(STATE.AUTHENTICATION);
    const { currentQuestion } = getState(STATE.QUIZ);

    Sentry.withScope(scope => {
      scope.setTag('caught-in', 'Timer');
      scope.setUser({ username });
      scope.setExtra('current-question', JSON.stringify(currentQuestion));

      if (typeof time !== 'number') {
        Sentry.captureMessage(`[Timer]: time is not a number. time: ${time}`);
      }

      if (time <= 0) {
        Sentry.captureMessage(`[Timer]: time is negative. time: ${time}`);
      }

      setTimeout(() => reloadPageWithNewCookie(quizId), 400);
    });

    return null;
  }

  return (
    hasEndTime && (
      <div
        style={{
          display: 'inline-block',
          zIndex: 999,
          position: 'sticky',
          top: 20,
          marginTop: -8,
          marginBottom: 12,
        }}
      >
        <Text upgrade font="secondary" size={12} letterSpacing="0.6px" weight="medium" color="grey-6">
          TIME LEFT
        </Text>

        <br />

        <Countdown
          now={getNow}
          date={questionEndTime}
          onTick={({ minutes, seconds }) => onChange(time - (minutes * 60 + seconds))}
          renderer={({ minutes, seconds, completed }) => {
            if (completed) {
              onTimeout();
            }

            return (
              <Text
                upgrade
                size={48}
                weight="extrabold"
                style={{ lineHeight: '56px' }}
                color={minutes === 0 && seconds <= 10 ? 'red-4' : 'grey-6'}
              >
                {`0${minutes}`.slice(-2)}:{`0${seconds}`.slice(-2)}
              </Text>
            );
          }}
        />
      </div>
    )
  );
};

export default React.memo(Timer);
